import { createSwrKeyedStore } from './swr/createSwrKeyedStore';
import { getOrgAsset } from '../lib/api';
import { normalizeAssetImageFields } from '../utils/assetImageResolver';

const swr = createSwrKeyedStore({
  name: 'OrgAssetDetailsStore',
  storageKey: 'bookthing-org-asset-details',
  fetcher: async (id) => {
    const resp = await getOrgAsset(id);
    if (!resp?.success || !resp.asset) throw new Error('Failed to load asset');
    return normalizeAssetImageFields(resp.asset);
  },
});

export const useOrgAssetDetailsStore = swr.useStore;
export const useOrgAssetDetail = swr.useEntry;
export const fetchOrgAssetDetailIfStale = swr.fetchIfStale;
